export default defineNuxtRouteMiddleware((to) => {
  const disallowedPaths = ["city-id.html", "destinations", "como-funciona.html"]
  if (disallowedPaths.some(path => typeof to.name === 'string' && to.name.includes(path))) {
    return navigateTo('/')
  }
})